import React from 'react';
import { useSelector } from 'react-redux';

const Dashboard = () => {
  //get user detail
  const userData = useSelector((state) => state.auth.userData);
  const userName = userData.salutation+ " "+userData.first_name+" "+userData.last_name;

  return (
    <div className="row pb-5 mb-5">
        {/* Main Content Area */}
        <div className="col-12">
          {/* Welcome Section */}
          <div className="bg-white p-5 rounded-3 shadow-sm mb-4">
            <h2 className="display-6 fw-bold">Welcome back, {userName}! 👋</h2>
            
          </div>
        </div>
      </div>
  );
};

export default Dashboard;